import { CampaignContentPreferences } from 'types'
import { Campaign } from './Types'
import Styles from './CampaignDetails.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import ToggleButton from 'common/ToggleButton/ToggleButton'

interface SourcesTogglesProps {
  campaign: Campaign
  onUpdateContentPreferences: (contentPreferences: CampaignContentPreferences) => void
}

export const SourcesToggles = ({ campaign, onUpdateContentPreferences }: SourcesTogglesProps) => {
  return (
    <div className={Styles.toggleButtonContainer}>
      <div
        className={Styles.toggleOption}
        onClick={() =>
          onUpdateContentPreferences({
            use_only_campaign_source_materials: !campaign.content_preferences?.use_only_campaign_source_materials,
          })
        }
      >
        <div className={Styles.text}>
          <Text variant="largeList">Only use Source Materials attached to this campaign</Text>
          <Text variant="secondary" color="var(--dark-40)">
            Ignores webpages and documents from Brand Kit
          </Text>
        </div>
        <ToggleButton
          name="useBrandKitSourceMaterials"
          size="sm-md"
          checked={!!campaign.content_preferences?.use_only_campaign_source_materials}
          handleChange={() =>
            onUpdateContentPreferences({
              use_only_campaign_source_materials: !campaign.content_preferences?.use_only_campaign_source_materials,
            })
          }
        />
      </div>
      <div
        className={Styles.toggleOption}
        onClick={() =>
          onUpdateContentPreferences({
            use_only_campaign_media: !campaign.content_preferences?.use_only_campaign_media,
          })
        }
      >
        <div className={Styles.text}>
          <Text variant="largeList">Only use Media attached to this campaign</Text>
          <Text variant="secondary" color="var(--dark-40)">
            Ignores images and videos from Brand Kit
          </Text>
        </div>
        <ToggleButton
          name="useBrandKitMedia"
          size="sm-md"
          checked={!!campaign.content_preferences?.use_only_campaign_media}
          handleChange={() =>
            onUpdateContentPreferences({
              use_only_campaign_media: !campaign.content_preferences?.use_only_campaign_media,
            })
          }
        />
      </div>
      <div
        className={Styles.toggleOption}
        onClick={() =>
          onUpdateContentPreferences({ ignore_brand_profile: !campaign.content_preferences?.ignore_brand_profile })
        }
      >
        <div className={Styles.text}>
          <Text variant="largeList">Use my Brand Business Profile</Text>
          <Text variant="secondary" color="var(--dark-40)">
            Saved details about your business
          </Text>
        </div>
        <ToggleButton
          name="useBrandKitBusinessProfile"
          size="sm-md"
          checked={!campaign.content_preferences?.ignore_brand_profile}
          handleChange={() =>
            onUpdateContentPreferences({
              ignore_brand_profile: !campaign.content_preferences?.ignore_brand_profile,
            })
          }
        />
      </div>
    </div>
  )
}
